export const SIGN_IN_PATH = '/login';
export const SIGN_OUT_PATH = '/logout';
export const RESET_PASSWORD_PATH = '/user/$username/password';
export const RESET_PASSWORD_TOKEN_PATH = '/user/$username/password/token-request?app=$app';
export const RESET_PASSWORD_BY_ADMIN_PATH = '/users/$userId/password';
